module.exports = __webpack_public_path__ + "img/html5.e0787e40.png";